import { render, staticRenderFns } from "./OrganisationUserForm.vue?vue&type=template&id=5684e65b&scoped=true&"
import script from "./OrganisationUserForm.vue?vue&type=script&lang=js&"
export * from "./OrganisationUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684e65b",
  null
  
)

export default component.exports